import { useQuery } from "@tanstack/react-query";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../app-context";
import { DealerData, DealerResponse, ResponseSelector } from "../types";
import { UserLocationContext } from "../UserLocation/UserLocationContext";
import { get } from "./getGeneric";
import useDealersQuery from "./use-dealers-query";

const useSingleDealerQuery = (id: string) => {

  const { globalApi } = useContext(AppContext);
  const { postalCode } = useContext(UserLocationContext);

  const [ makeSecondQuery, setMakeSecondQuery ] = useState(false);

  const getSingleDealer: ResponseSelector<DealerResponse, DealerData> = (res: DealerResponse) => (res?.data as DealerData[]).find(x => x.static_dealer_id === id) as DealerData;

  const firstQuery = useDealersQuery({
    select: getSingleDealer,
    additionalDependencies: !!id
  });

  const { isSuccess, data } = firstQuery;

  const params = `static_dealer_id=${id}&address=${postalCode}`;
  const url = `${globalApi}/inventory-app/dealers?${params}`;

  const secondQuery = useQuery({
    queryKey: ['single-dealer', params],
    queryFn: () => get<DealerResponse>(url),
    select: getSingleDealer,
    enabled: makeSecondQuery && !!id
  });

  useEffect(() => {
    if (isSuccess && !data) {
      setMakeSecondQuery(true);
    }
  }, [isSuccess, data]);

  return isSuccess && data ? firstQuery : secondQuery;
};

export default useSingleDealerQuery;
